<template>
  <app-modal name="tag-modal" :submit-on-enter="false" :title="title" @before-open="beforeOpen"
    @before-close="beforeClose" width="35%" @on-ok="onOk">
    <app-form ref="tagForm" @on-submit="onSubmit" :schema="schema" :data="formModel" />
    <div class="d-flex w-100 justify-content-evenly flex-wrap">
      <div v-for="rect in rectangles" :key="rect.id" style="width: 60px; height: 60px" class="d-flex justify-content-center align-items-center">
         <div :style="{backgroundColor: rect.color, width: '40px', height: '40px', 'border': rect.color === chosenColor ? '2px solid #000' : 'none'}" @click="chosenColor = rect.color"></div>
      </div>
    </div>
  </app-modal>
  <!-- Choose color from palette -->
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/';
import { mapActions } from 'vuex';


export default {
  name: 'TagModal',
  components: {
    AppForm,
    AppModal,
  },
  data() {
    return {
      title: 'Create Tag',
      schema: {
        name: {
          label: this.$t('tag.name'),
          placeholder: `${this.$t('app.enter')} ${this.$t('tag.name')}`,
          type: 'input',
          validation: 'required|min:2',
        },
      },
      formModel: {
        name: null,
        id: null,
      },
      chosenColor: null
    };
  },
  methods: {
    ...mapActions(['createTag', 'updateTag']),
    onSubmit(formModel) {
      const vm = this;
      this.$refs.tagForm.validate().then((isValid) => {
        if (isValid) {
          const action = this.formModel.id ? this.updateTag : this.createTag;
          action({
            id: this.formModel.id,
            name: formModel.name,
            hex_color: this.chosenColor
          }).then(() => {
            vm.$bus.emit('close-tag-modal');
            vm.$modal.hide('tag-modal', { isOk: true });
          });
        }
      });
    },
    onOk() {
      this.$refs.tagForm.submit();
    },

    beforeClose() {
      this.formModel = {
        name: null,
      };
    },
    beforeOpen(params) {
      this.title = params.model.id ? this.$t('tag.editTag') : this.$t('tag.createTag');
      if (params.model.id) {
        this.formModel = {
          id: params.model.id,
          name: params.model.name,
        };
      }
      this.rectangles = [
        { id: 1073, color: "#005DCA" },
        { id: 1074, color: "#34D1F0" },
        { id: 1075, color: "#0AD699" },
        { id: 1076, color: "#936DE3" },
        { id: 1077, color: "#FF7676" },
        { id: 1078, color: "#FFCF82" },
        { id: 1079, color: "#D857FF" },
        { id: 1080, color: "#00447C" },
        { id: 1081, color: "#2198B0" },
        { id: 1082, color: "#01B27D" },
        { id: 1083, color: "#6B47B6" },
        { id: 1084, color: "#C35656" },
        { id: 1085, color: "#FB9D05" },
        { id: 1086, color: "#EBADFE" }
      ];
    },
  },
};
</script>
<!-- <style scoped>
.selected {
  border: 2px solid #000;
}
</style> -->


// WEBPACK FOOTER //
// src/portal-components/tag/tag-modal.vue